class GiftWrapQuote extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.gift-wrap-quote__checkbox');
    this.details = this.querySelector('.gift-wrap-quote__details');
    this.saveButton = this.querySelector('.gift-wrap-quote__save');
    this.message = this.querySelector('.gift-wrap-quote__message');
    this.errorMessage = this.querySelector('.gift-wrap-quote__error');
    this.noItemsError = this.querySelector('.gift-wrap-quote__no-items-error');
    this.noPhoneError = this.querySelector('.gift-wrap-quote__no-phone-error');
    this.phoneField = this.querySelector('.gift-wrap-quote__phone-field');

    this.onToggle = this.onToggle.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDeliveryChange = this.onDeliveryChange.bind(this);

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.onToggle);
    }
    if (this.saveButton) {
      this.saveButton.addEventListener('click', this.onSave);
    }
    this.querySelectorAll('.gift-wrap-quote__delivery').forEach((input) => {
      input.addEventListener('change', this.onDeliveryChange);
    });
  }

  show(element) {
    if (element) element.style.display = '';
  }

  hide(element) {
    if (element) element.style.display = 'none';
  }

  onToggle() {
    if (!this.details) return;
    if (this.checkbox.checked) {
      this.show(this.details);
    } else {
      this.hide(this.details);
    }
  }

  onDeliveryChange() {
    const deliveryInput = this.querySelector('.gift-wrap-quote__delivery:checked');
    if (deliveryInput && deliveryInput.value === 'Text') {
      this.show(this.phoneField);
    } else {
      this.hide(this.phoneField);
    }
  }

  getCartRoute(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/$/, '')}${path}`;
  }

  hideMessages() {
    this.hide(this.message);
    this.hide(this.errorMessage);
    this.hide(this.noItemsError);
    this.hide(this.noPhoneError);
  }

  onSave(event) {
    event.preventDefault();
    this.hideMessages();

    const wrapRequested = !!(this.checkbox && this.checkbox.checked);
    const itemCheckboxes = Array.from(this.querySelectorAll('.gift-wrap-quote__item'));
    const checkedItems = itemCheckboxes.filter((checkbox) => checkbox.checked);

    if (wrapRequested && itemCheckboxes.length > 0 && checkedItems.length === 0) {
      this.show(this.noItemsError);
      return;
    }

    const deliveryInput = this.querySelector('.gift-wrap-quote__delivery:checked');
    const phoneInput = this.querySelector('.gift-wrap-quote__phone');
    const deliveryValue = deliveryInput ? deliveryInput.value : 'Email';

    if (wrapRequested && deliveryValue === 'Text' && (!phoneInput || !phoneInput.value.trim())) {
      this.show(this.noPhoneError);
      return;
    }

    this.saveButton.classList.add('loading');
    this.saveButton.setAttribute('disabled', 'disabled');

    const styleInput = this.querySelector('.gift-wrap-quote__style:checked');
    const occasionInput = this.querySelector('.gift-wrap-quote__occasion');
    const recipientInput = this.querySelector('.gift-wrap-quote__recipient');
    const colorInput = this.querySelector('.gift-wrap-quote__color');
    const notesInput = this.querySelector('.gift-wrap-quote__notes');

    const itemTitles = checkedItems.map((checkbox) => checkbox.dataset.title).join(', ');
    const itemKeys = checkedItems.map((checkbox) => checkbox.value).join(',');

    const attributes = {
      'Gift Wrapping': wrapRequested ? 'Yes' : '',
      'Wrapping Style': wrapRequested && styleInput ? styleInput.value : '',
      'Items to Wrap': wrapRequested ? itemTitles : '',
      '_Items to Wrap Keys': wrapRequested ? itemKeys : '',
      'Gift Occasion': wrapRequested && occasionInput ? occasionInput.value : '',
      'Gift Recipient': wrapRequested && recipientInput ? recipientInput.value : '',
      'Favorite Color': wrapRequested && colorInput ? colorInput.value : '',
      'Wrapping Notes': wrapRequested && notesInput ? notesInput.value : '',
      'Quote Delivery': wrapRequested ? deliveryValue : '',
      'Quote Phone Number': wrapRequested && deliveryValue === 'Text' && phoneInput ? phoneInput.value : ''
    };

    fetch(this.getCartRoute('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart update failed with status ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        this.saveButton.classList.remove('loading');
        this.saveButton.removeAttribute('disabled');
        this.show(this.message);
      })
      .catch((error) => {
        console.error('Gift wrap quote update failed:', error);
        this.saveButton.classList.remove('loading');
        this.saveButton.removeAttribute('disabled');
        this.show(this.errorMessage);
      });
  }
}

if (!customElements.get('gift-wrap-quote')) {
  customElements.define('gift-wrap-quote', GiftWrapQuote);
}
